import React from "react";
import "../styles/Navbar.css";
import logo from "../assets/logo_see.png";
import { useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { path: "/", icon: "fa-home", label: "Inicio" },
    { path: "/mapa", icon: "fa-map", label: "Mapa" },
    { path: "/cotizar", icon: "fa-money-bill-1", label: "Cotizar" },
    { path: "/agencias", icon: "fa-building", label: "Agencias" },
    { path: "/aduanas-puertos", icon: "fa-ship", label: "Aduanas y Puertos" },
    { path: "/transportistas", icon: "fa-truck", label: "Transportes" }
  ];

  const actionItems = [
    { path: "/perfil", icon: "fa-user-circle" }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-logo" onClick={() => navigate("/")}>
        <img src={logo} alt="See Logis" />
        <span class="notranslate" translate="no">See Logis</span>
      </div>

      <ul className="navbar-links">
        {navItems.map(({ path, icon, label }) => (
          <li
            key={path}
            className={isActive(path) ? "active" : ""}
            onClick={() => navigate(path)}
          >
            <i className={`fas ${icon}`}></i>
            <span>{label}</span>
          </li>
        ))}
      </ul>

      <div className="navbar-actions">
        {actionItems.map(({ path, icon }) => (
          <i
            key={path}
            className={`fas ${icon} ${isActive(path) ? "active" : ""}`}
            onClick={() => navigate(path)}
          ></i>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;


